export default {
  mutedTextColor: Styles.color.black,
};
